export default __webpack_public_path__ + "448043b.png";